import { ThemeOptions } from '@mui/material/styles/createTheme';

export enum Breakpoints {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
}

export const breakpoints: ThemeOptions['breakpoints'] = {
  values: {
    [Breakpoints.xs]: 0,
    [Breakpoints.sm]: 320,
    [Breakpoints.md]: 720,
    [Breakpoints.lg]: 1080,
    [Breakpoints.xl]: 1920,
  },
};
